import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { countries } from '../../utils/countries'
import { dismissModal } from '../../service/modal-service'
import ReactCountryFlag from 'react-country-flag'
import { CloseButton } from './buttons/CloseButton'
import { modalVariants } from 'utils/frame-motion-variants'

export const CountrySelection = (props) => {

    const setLoginTelCd = props.setLoginTelCd
    const setLoginCountryCd = props.setLoginCountryCd

    const [ countryList, setCountryList ] = useState(countries)
    const [ searchText, setSearchText ] = useState("")
    
    const selectCountry = (loginTelCd, loginCountryCd) => {
        setLoginTelCd(loginTelCd)
        setLoginCountryCd(loginCountryCd)
        dismissModal()
    }

    const handleSearch = (e) => {
        e.preventDefault()
        setSearchText(e.target.value) 
        setCountryList(countries.filter((list) => JSON.stringify(list).toLowerCase().indexOf(e.target.value.toLowerCase()) != -1))
    }

  return (
    <div className="flex justify-center items-center right-0 top-0 fixed z-30 w-full h-full backdrop-blur-sm bg-black/10 overflow-y-scroll">
        <motion.div
            className="mx-2 h-145 max-w-sm w-full relative bg-white rounded-lg shadow modal-height overflow-y-scroll"
                variants={modalVariants}
                initial="initial"
                animate="animate"
                exit="exit" 
            >
            <div className='relative h-20 w-full bg-white'>
                <div className="fixed px-4 py-4 rounded-t border-b space-x-5 flex justify-between items-center bg-white w-full max-w-sm">
                    <input
                        type="search"
                        className="pl-5 px-3 py-3 text-orange-600 w-full shadow appearance-none border rounded  focus:outline-none focus:shadow-outline focus:shadow-sm focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                        placeholder="Search" name="searchText" value={searchText} onChange={(e) => handleSearch(e)}
                        style={{ transition: "all .15s ease" }} required
                    />
                    <div>
                        <CloseButton/>
                    </div>
                </div>
            </div>
            {[...countryList].map((country, i) => 
                <div key={i} className='py-2 px-4'>
                    <button type='button' onClick={() => selectCountry("+" + country.code, country.cca2)}
                        className='flex space-x-2 items-center text-gray-500'>
                                <ReactCountryFlag className='shadow-md'
                                    countryCode={country.cca2}
                                    svg
                                    style={{
                                        width: '1.3em',
                                        height: '1.3em',
                                    }}
                                    title={country.cca2}
                                />
                            <span>{country.code}</span>
                            <span>{country.name}</span>
                        </button>
                </div>        
            )} 
        </motion.div>
    </div>
  )
}
